import Menu from '@/global/components/MenuV2'
import { cn } from '@/lib/utils'
import { Button, ButtonProps, MenuItemProps } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface IPropsMenuButton extends ButtonProps {
    children?: React.ReactNode
    startIcon: JSX.Element
    label: string
}

export function GridMenuButton({
    children,
    startIcon,
    label,
    ...rest
}: IPropsMenuButton) {
    return (
        <Menu.Root id={rest.id}>
            <Menu.Trigger>
                <GridButton {...{ startIcon, label, ...rest }} />
            </Menu.Trigger>
            <Menu.List>{children}</Menu.List>
        </Menu.Root>
    )
}

interface IGridButtonProps extends ButtonProps {
    href?: string
    onlyView?: number | number[]
    startIcon: JSX.Element
    label: string
}

export function GridButton({
    label,
    href,
    onClick,
    ...props
}: IGridButtonProps) {
    const navigate = useNavigate()

    return (
        <Button
            {...props}
            variant="text"
            className={cn(
                'flex flex-row items-center',
                'justify-start md:justify-center md:w-fit w-full',
                'h-9 text-xs',
            )}
            onClick={e => {
                if (href) {
                    e.preventDefault()
                    onClick?.(e)
                    navigate(href)
                } else if (onClick) {
                    onClick(e)
                }
            }}
        >
            <span>{label}</span>
            {props.children}
        </Button>
    )
}

export function GridMenuItem({
    label,
    startIcon = <React.Fragment />,
    ...props
}: MenuItemProps & {
    href?: string
    startIcon?: JSX.Element
    label: string
}) {
    return (
        <Menu.Item {...props}>
            {React.cloneElement(startIcon, {
                sx: { mr: 1 },
            })}
            <span>{label}</span>
            {props.children}
        </Menu.Item>
    )
}
